import type { Address } from 'viem';

export interface TokenInfo {
  address: Address;
  symbol: string;
  name: string;
  decimals: number;
  logoURI?: string;
}

/**
 * Hardcoded token list for Ethereum Mainnet
 * Source: CoinGecko and official token contracts
 */
export const ETHEREUM_TOKENS: TokenInfo[] = [
  {
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    symbol: 'USDT',
    name: 'Tether USD',
    decimals: 6,
  },
  {
    address: '0x4a220E6096B25EADb88358cb44068A3248254675',
    symbol: 'QNT',
    name: 'Quant',
    decimals: 18,
  },
  {
    address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
    symbol: 'SHIB',
    name: 'Shiba Inu',
    decimals: 18,
  },
  {
    address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
    symbol: 'UNI',
    name: 'Uniswap',
    decimals: 18,
  },
  {
    address: '0x0Cf0Ee63788A0849fE5297F3407f701E122cC023',
    symbol: 'DATA',
    name: 'Streamr',
    decimals: 18,
  },
  {
    address: '0x582d872A1B094FC48F5DE31D3B73F2D9bE47def1',
    symbol: 'TON',
    name: 'Toncoin',
    decimals: 9,
  },
  {
    address: '0x455e53CBB86018Ac2B8092FdCd39d8444aFFC3F6',
    symbol: 'POL',
    name: 'Polygon Ecosystem Token',
    decimals: 18,
  },
  {
    address: '0x1151CB3d861920e07a38e03eEAd12C32178567F6',
    symbol: 'BONK',
    name: 'Bonk',
    decimals: 5,
  },
  {
    address: '0x8D983cb9388EaC77af0474fA441C4815500Cb7BB',
    symbol: 'ATOM',
    name: 'Cosmos Hub',
    decimals: 6,
  },
];

/**
 * Get token info by address
 */
export function getTokenByAddress(address: Address): TokenInfo | undefined {
  return ETHEREUM_TOKENS.find((token) => token.address.toLowerCase() === address.toLowerCase());
}

/**
 * Get token info by symbol
 */
export function getTokenBySymbol(symbol: string): TokenInfo | undefined {
  return ETHEREUM_TOKENS.find((token) => token.symbol.toLowerCase() === symbol.toLowerCase());
}
